import PeriodPicker from 'components/PeriodPicker';
import { PERIODS } from 'components/PeriodPicker/periods/constants';
import moment from 'moment';

const defaultCustomRange = date =>
  date.isBefore(moment().subtract(6, 'month')) || date.isAfter(moment());

const ProjectsPeriodPicker = ({
  period,
  setPeriod,
  disabled = false,
  hiddenPeriods = [],
  isCustomDateOutsideRange = defaultCustomRange
}) => {
  return (
    <PeriodPicker
      currentPeriod={period}
      onChange={newPeriod =>
        setPeriod({
          periodKey: newPeriod.selectedPeriodKey,
          before: newPeriod.end_date,
          after: newPeriod.start_date
        })
      }
      size='medium'
      width='18rem'
      showCalendarIcon={true}
      hiddenPeriods={[
        PERIODS.ITERATIONS.periodKey,
        PERIODS.PAST_90_DAYS.periodKey,
        ...hiddenPeriods.map(period => period.periodKey)
      ]}
      disabled={disabled}
      isCustomDateOutsideRange={isCustomDateOutsideRange}
    />
  );
};

export default ProjectsPeriodPicker;
